<template>
  <div>
    <div class="margin-top-xs">
      <span class="firstTitle"><i></i>{{title}}</span>
      <dv-scroll-board
        :config="config"
        class="margin-top-sm realTimeList"
        :class="{'is400':is400,'is155':is155,'is100':is100,'is120':is120,'is600':is600,'is760':is760}"
      >
      </dv-scroll-board>
    </div>
  </div>
</template>

<script>
import SecondTitle from "../secondTitle.vue";
import { indexRight } from "@/api/indexRight";
import { siteRight } from "@/api/singleSite/right";
import Title from "../title";
import {formatTime} from '@/utils/index'

export default {
  data() {
    return {
    };
  },
  components: {
    SecondTitle,
    Title,
  },
  props: {
    title: {
      type: String,
      default: () => (''),
    },
    config:{
      type: Object,
      default: () => ({}),
    },
    is400:{
      type: Boolean,
      default: () => (false),
    },
    is155:{
      type: Boolean,
      default: () => (false),
    },
    is600:{
      type: Boolean,
      default: () => (false),
    },
    is760:{
      type: Boolean,
      default: () => (false),
    },
    is100:{
      type: Boolean,
      default: () => (false),
    },
    is120:{
      type: Boolean,
      default: () => (false),
    },
  },
  watch: {},
  mounted() {
  },
  methods: {
    getData(data) {
      
    },
  },
};
</script>
<style lang="scss" scoped>
.realTimeList {
  width: 590px;
  height: 500px;
  &.is400{
    height: 400px;
  }
  &.is155{
    height: 155px;
  }
  &.is600{
    height:600px;
  }
  &.is760{
    width:760px;
    height:350px;
  }
  &.is100{
    height:100px;
  }
  &.is120{
    height:120px;
  }
}
.firstTitle {
  width: 590px;
  height: 35px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 34px;
  display: flex;
  background: url("~@/assets/images/index/title.png") no-repeat;
  background-size: cover;
  padding-left: 30px;
}
</style>